<template>
    <a
        v-if="isLoading"
        :href="policyUrl"
        class="inline-block btn-black-on-gray-pill"
        v-text="fallbackLinkText"
    />
    <div class="copy-block" v-else v-html="policyContent"></div>
</template>
<script setup>
import { computed, onMounted, ref } from "vue";
import { useIubenda } from "@/Composables";

const { loadPolicy, fallbackUrl } = useIubenda()

const { type, fallbackLinkText } = defineProps({
    type: {
        type: String,
        required: true,
        validator: (value) => ['terms-and-conditions', 'privacy-policy'].includes(value),
    },
    fallbackLinkText: {
        type: String,
        required: true,
    }
})

const isLoading = ref(true)
const policyContent = ref(null)
const policyUrl = computed(() => fallbackUrl(type))

onMounted(() => {
    loadPolicy(type)
        .then((response) => {
            policyContent.value = response.data.content
        })
        .finally(() => {
            isLoading.value = false
        })
})

</script>
